import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { removeToken } from "../../ auth";
import api from "../../services/api";
import "bootstrap-icons/font/bootstrap-icons.css";
import logo from "../../assets/img/logoN.png";

export default function SidebarDistrict() {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const [isOpen, setIsOpen] = useState(false);
  const [districtName, setDistrictName] = useState("");

  const handleToggle = () => setIsOpen(!isOpen);
  const handleLogout = () => {
    removeToken();
    navigate("/");
  };

  useEffect(() => {
    const fetchDistrictName = async () => {
      try {
        const me = await api.get("/auth/me/district");
        const { district_id } = me.data;
        if (district_id) {
          const res = await api.get(`/districtStats/district/${district_id}/name`);
          setDistrictName(res.data.name);
        }
      } catch (err) {
        console.error("Erreur chargement district:", err);
      }
    };
    fetchDistrictName();
  }, []);

  return (
    <>
      {/* Barre horizontale pour mobile */}
      <nav className="d-lg-none bg-dark text-white shadow-sm position-fixed top-0 start-0 end-0" style={{ zIndex: 1000 }}>
        <div className="container-fluid">
          <div className="d-flex align-items-center justify-content-between flex-wrap py-2">
            <div
              className="d-flex align-items-center cursor-pointer flex-grow-1"
              onClick={() => navigate("/dashboard-district")}
              style={{ cursor: "pointer", minWidth: 0 }}
            >
              <img src={logo} alt="logo" style={{ height: "40px", marginRight: "10px", flexShrink: 0 }} />
              <div className="d-flex flex-column" style={{ minWidth: 0, overflow: "hidden" }}>
                <span className="fs-6 fw-bold">District</span>
                {districtName && (
                  <small className="text-light text-truncate">{districtName}</small>
                )}
              </div>
            </div>
            <button
              className="btn btn-outline-light"
              type="button"
              onClick={handleToggle}
            >
              <i className={`bi ${isOpen ? "bi-x" : "bi-list"}`}></i>
            </button>
          </div>
          {/* Menu déroulant mobile */}
          <div className={`${isOpen ? "d-block" : "d-none"} pb-2`}>
            <div className="d-flex flex-column gap-2">
              <button
                className={`btn text-white text-start w-100 ${
                  isActive("/dashboard-district") && !isActive("/dashboard-district/preuves") ? "fw-bold bg-secondary" : ""
                }`}
                onClick={() => {
                  navigate("/dashboard-district");
                  setIsOpen(false);
                }}
              >
                <i className="bi bi-people me-2"></i>Visualiser les élèves
              </button>
              <button
                className={`btn text-white text-start w-100 ${
                  isActive("/dashboard-district/preuves") ? "fw-bold bg-secondary" : ""
                }`}
                onClick={() => {
                  navigate("/dashboard-district/preuves");
                  setIsOpen(false);
                }}
              >
                <i className="bi bi-check-circle me-2"></i>Valider les exigences
              </button>
              <button 
                className="btn btn-outline-danger btn-sm" 
                onClick={handleLogout}
              >
                <i className="bi bi-box-arrow-left me-1"></i>Déconnexion
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar vertical pour desktop */}
      <div
        className="d-none d-lg-flex flex-column justify-content-between flex-shrink-0 p-3 bg-dark text-white shadow-sm"
        style={{ width: "250px", minHeight: "100vh" }}
      >
        <div>
          <div
            className="d-flex flex-column align-items-center mb-4"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/dashboard-district")}
          >
            <img src={logo} alt="logo" style={{ height: "40px", marginBottom: "5px" }} />
            <span className="fs-5 fw-bold text-white">District</span>
            {districtName && (
              <small className="text-light mt-1">{districtName}</small>
            )}
          </div>

          <ul className="nav nav-pills flex-column mb-auto">
            <li className="nav-item mb-3">
              <button
                className={`btn text-start text-white w-100 ${
                  isActive("/dashboard-district") && !isActive("/dashboard-district/preuves") ? "fw-bold" : ""
                }`}
                onClick={() => navigate("/dashboard-district")}
              >
                <i className="bi bi-people me-2"></i>Visualiser les élèves
              </button>
            </li>
            <li className="nav-item mb-3">
              <button
                className={`btn text-start text-white w-100 ${
                  isActive("/dashboard-district/preuves") ? "fw-bold" : ""
                }`}
                onClick={() => navigate("/dashboard-district/preuves")}
              >
                <i className="bi bi-check-circle me-2"></i>Valider les exigences
              </button>
            </li>
          </ul>
        </div>

        <div className="mt-4 pt-2 border-top border-light">
          <button className="btn btn-outline-danger w-100 mt-3" onClick={handleLogout}>
            <i className="bi bi-box-arrow-left me-2"></i>Déconnexion
          </button>
        </div>
      </div>
    </>
  );
}
